module.exports = __webpack_public_path__ + "img/education-service.cb9aa053.png";